const prefix = ''

export const measurementsUrls = {
  'measurements.list': `${prefix}/measurements`,
  'labels.list': `${prefix}/labels`,
  'labels.single': (labelId = ':labelId') => `${prefix}/labels/${labelId}`,
}
